module.exports = __webpack_public_path__ + "img/marmelaedchen-pflaumen_xs.de9301ed.jpg";